import { render, staticRenderFns } from "./printTask.vue?vue&type=template&id=65916fc2&scoped=true"
import script from "./printTask.vue?vue&type=script&lang=js"
export * from "./printTask.vue?vue&type=script&lang=js"
import style0 from "./printTask.vue?vue&type=style&index=0&id=65916fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65916fc2",
  null
  
)

export default component.exports